import type { PretendCommitmentCommandData } from '@festina/life-general-types/life'

import { PretendDeathCommand } from '../../actions/PretendDeathCommand'
import { LifeCommandModalButtonFallback } from '../LifeCommandModalButtonFallback'
import type { CommandDataRecord } from '../types'

export const pretendCommands: CommandDataRecord<
  PretendCommitmentCommandData['_type']
> = {
  PretendCommitmentCommandData: LifeCommandModalButtonFallback,
  PretendDeathCommandData: PretendDeathCommand,
}
